var _circle, _path, _circle2, _path2, _circle3, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItemAnimation03(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 112,
    viewBox: "0 0 136 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 104,
    r: 8,
    fill: "#01C060"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7388 102.872L33.4679 104.013L36.3681 106.815L41.0929 102.188L39.8221 100.983L36.3681 104.437L34.7388 102.872Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#01C060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.955 27.4899L17.8712 32.0517L29.4719 43.2612L48.3711 24.753L43.2879 19.9303L29.4719 33.7463L22.955 27.4899Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 33,
    r: 16,
    fill: "#01C060"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.477 30.7451L112.936 33.026L118.736 38.6308L128.186 29.3767L125.644 26.9653L118.736 33.8733L115.477 30.7451Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemAnimation03);
export default __webpack_public_path__ + "static/media/item-animation-03.61928c7a3014068923fad0d4d043c756.svg";
export { ForwardRef as ReactComponent };